import { client } from "./axios";
import { HomeInfoDto } from "../types/HomeInfo";
import { UserInfoDto } from "../types/UserInfo";
import { UserSubscriptionDto } from "../types/UserSubscription";
import { ConfigDto } from "../types/Config";

export const homeApi = {
  getMainMenu: async (): Promise<HomeInfoDto> => {
    const response = await client.get<HomeInfoDto>("/mainMenu");
    return response.data;
  },

  getUserInfo: async (): Promise<UserInfoDto> => {
    const response = await client.get<UserInfoDto>("/users/me");
    return response.data;
  },
  
  getUserSubscription: async (): Promise<UserSubscriptionDto|null> => {
    const response = await client.get("/users/subscription");
    return response.data;
  },
  getConfig: async (): Promise<ConfigDto> => {
    const response = await client.get("/config");
    return response.data;
  },
};
